import {
  Button,
  DialogActions,
  Grid,
  Theme,
  withStyles
} from '@material-ui/core'
import { CloseDialog } from '../../actions/types'
import i18n from '../../translations/i18n'
import { MuiClasses } from '../../types'

interface DialogButtonsProps {
  classes: MuiClasses
  closeDialog: CloseDialog
  dialogName: string
  ButtonTwo?: JSX.Element
}

const styles = ({ breakpoints, spacing }: Theme) => ({
  backBtn: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '10px',
    padding: '6px 16px',
    lineHeight: '1.75'
  }
})

const DialogButtons = ({
  classes,
  dialogName,
  closeDialog,
  ButtonTwo
}: DialogButtonsProps) => (
  <Grid container>
    <Grid item xs={12}>
      <DialogActions>
        <Grid container justify='space-between' alignItems='baseline'>
          <Grid item xs={6}>
            <Button
              onClick={() => closeDialog(dialogName)}
              className={classes.backBtn}
            >
              {i18n.t('general.cancel')}
            </Button>
          </Grid>
          <Grid item xs={6} style={{ flexBasis: '0' }}>
            {ButtonTwo}
          </Grid>
        </Grid>
      </DialogActions>
    </Grid>
  </Grid>
)

export default withStyles(styles)(DialogButtons)
